/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import Helmet from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"

const SEO = ({ description, lang, meta, keywords, title }) => {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
            favicon
          }
        }
      }
    `
  );
  
  const metaDescription = description || site.siteMetadata.description;

  const faviconLink = {
    rel: 'shortcut icon',
    type: 'image/png',
    href: site.siteMetadata.favicon
  };

  const fonts = [
    'https://cdn.ncsoft.com/dependencies/fonts/ncfonts/fonts.css',
  ].map(font => ({
    rel: 'stylesheet',
    crossOrigin: 'anonymous',
    href: font,
  }));

  const link = [ faviconLink ].concat(fonts);

  const metaTags = [
    {
      name: 'description',
      content: metaDescription,
    },
    {
      property: 'og:title',
      content: `${title} | ${site.siteMetadata.title}`,
    },
    {
      property: 'og:description',
      content: metaDescription,
    },
    {
      property: 'og:type',
      content: 'website',
    },
    {
      name: 'twitter:card',
      content: 'summary',
    },
    {
      name: 'twitter:creator',
      content: '@NCSOFT_West',
    },
    {
      name: 'twitter:title',
      content: title,
    },
    {
      name: 'twitter:description',
      content: metaDescription,
    },
  ].concat(
    keywords.length > 0
      ? {
        name: `keywords`,
        content: keywords.join(`, `),
      }
      : []
  ).concat(meta);
  
  return (
    <Helmet
      htmlAttirbutes={{ lang }}
      title={title}
      titleTemplate={`%s | ${site.siteMetadata.title}`}
      link={link}
      meta={metaTags}
    />
  );
};

SEO.defaultProps = {
  lang: `en`,
  meta: [],
  keywords: [],
  description: ``,
}

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  keywords: PropTypes.arrayOf(PropTypes.string),
  title: PropTypes.string.isRequired,
}

export default SEO
